import "./team.css";
import I1 from "assets/png/exec1.png";
import I2 from "assets/png/exec2.png";
import I6 from "assets/png/exec6.png";

const Team = () => {
  return (
    <div className="team">
      <div className="three-block">
        <p className="subtitle gray pry-text">MEET THE GUIDING KNIGHTS</p>
        <p className="header purple pry-text center">
          Guiding <span className="gray">our</span> Vision, <br /> Leading
          <span className="gray"> our</span> Success.
        </p>
      </div>

      <div className="exec">
        <div className="pers">
          <img src={I1} alt="" />
          <div className="pers-dets">
            <p className="pry-text mid black">Wilfred Uzoma</p>
            <p className="pry-text content gray center">MD/CEO</p>
          </div>
        </div>

        <div className="pers">
          <img src={I2} alt="" />
          <div className="pers-dets">
            <p className="pry-text mid black">Chinenye Onuigbo</p>
            <p className="pry-text content gray center">
              Chief Financial Officer
            </p>
          </div>
        </div>

        <div className="pers">
          <img src={I6} alt="" />
          <div className="pers-dets">
            <p className="pry-text mid black">Edet Ene</p>
            <p className="pry-text content gray center">
              Chief Operation Officer
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
